import React from 'react';

const EmailModal = ({ 
  showEmailModal, 
  emailInput, 
  setEmailInput, 
  registrationLoading, 
  authError, 
  registerUser 
}) => {
  if (!showEmailModal) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      backdropFilter: 'blur(5px)'
    }}>
      <div style={{
        background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
        borderRadius: '1rem',
        padding: '2rem',
        maxWidth: '500px',
        width: '90%',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.5)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        position: 'relative'
      }}>
        {/* Header */}
        <div style={{
          textAlign: 'center',
          marginBottom: '2rem'
        }}>
          <h2 style={{
            margin: '0 0 1rem 0',
            fontSize: '1.8rem',
            fontWeight: '700',
            background: 'linear-gradient(to right, #ff4d4d, #f9cb28)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}>
            🎨 Welcome to AI Creator Studio!
          </h2>
          <p style={{
            margin: 0,
            fontSize: '1rem',
            color: '#cccccc',
            lineHeight: '1.5'
          }}>
            Get free access to all our amazing AI features:
          </p>
        </div>

        {/* Features List */}
        <div style={{
          background: 'rgba(255, 255, 255, 0.05)',
          borderRadius: '0.5rem',
          padding: '1.5rem',
          marginBottom: '2rem',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '1rem',
            fontSize: '0.9rem'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <span style={{ fontSize: '1.2rem' }}>🎨</span>
              <span>AI Image Generation</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <span style={{ fontSize: '1.2rem' }}>✏️</span>
              <span>Image Editing</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <span style={{ fontSize: '1.2rem' }}>🎵</span>
              <span>AI Karaoke Studio</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <span style={{ fontSize: '1.2rem' }}>💕</span>
              <span>AI Girlfriend Chat</span>
            </div>
          </div>
        </div>

        {/* Email Input */}
        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{
            display: 'block',
            fontSize: '0.9rem',
            fontWeight: '600',
            color: '#ffffff',
            marginBottom: '0.5rem'
          }}>
            📧 Enter your email to get started:
          </label>
          <input
            type="email"
            value={emailInput}
            onChange={(e) => setEmailInput(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && !registrationLoading && registerUser(emailInput)}
            placeholder="your.email@example.com"
            style={{
              width: '100%',
              padding: '1rem',
              background: 'rgba(255, 255, 255, 0.1)',
              border: '2px solid rgba(255, 255, 255, 0.2)',
              borderRadius: '0.5rem',
              color: '#ffffff',
              fontSize: '1rem',
              outline: 'none',
              transition: 'border-color 0.3s',
              boxSizing: 'border-box'
            }}
            onFocus={(e) => {
              e.target.style.borderColor = 'rgba(255, 77, 77, 0.5)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)';
            }}
          />
        </div>

        {/* Error Message */}
        {authError && (
          <div style={{
            background: 'rgba(255, 0, 0, 0.1)',
            border: '1px solid rgba(255, 0, 0, 0.3)',
            borderRadius: '0.5rem',
            padding: '0.75rem',
            marginBottom: '1rem',
            color: '#ff6b6b',
            fontSize: '0.9rem',
            textAlign: 'center'
          }}>
            {authError}
          </div>
        )}

        {/* Action Buttons */}
        <div style={{
          display: 'flex',
          gap: '1rem',
          marginBottom: '1rem'
        }}>
          <button
            onClick={() => registerUser(emailInput)}
            disabled={registrationLoading || !emailInput.trim()}
            style={{
              flex: 1,
              padding: '1rem',
              background: registrationLoading || !emailInput.trim() 
                ? 'rgba(255, 255, 255, 0.2)' 
                : 'linear-gradient(to right, #ff4d4d, #f9cb28)',
              border: 'none',
              borderRadius: '0.5rem',
              color: '#ffffff',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: registrationLoading || !emailInput.trim() ? 'not-allowed' : 'pointer',
              transition: 'all 0.3s',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}
          >
            {registrationLoading && (
              <div style={{
                width: '16px',
                height: '16px',
                border: '2px solid rgba(255, 255, 255, 0.3)',
                borderTop: '2px solid #ffffff',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
              }} />
            )}
            <span>{registrationLoading ? 'Creating Account...' : '🚀 Start Creating for FREE'}</span>
          </button>
        </div>

        {/* Privacy Notice */}
        <div style={{
          fontSize: '0.8rem',
          color: '#888888',
          textAlign: 'center',
          lineHeight: '1.4'
        }}>
          <p style={{ margin: '0 0 0.5rem 0' }}>
            🔒 Your email is safe with us. We only use it to save your creations.
          </p>
          <p style={{ margin: 0 }}>
            ✨ No spam, no ads, just pure AI creativity!
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailModal; 